import React from 'react';
import { connect } from 'react-redux';

import {
  enableDistanceReadout,
  disableDistanceReadout,
  selectTripTrailhead,
  deselectTripTrailhead,
  sidebarOpen
} from '../actions';
import LeafletMap from '../components/LeafletMap';

const mapStateToProps = (state) => {
  const { tripsTrailheads, browser, sidebar } = state;
  const isMobile = browser.lessThan.small;

  return {
    sidebar: sidebar.open,
    isMobile,
    trailheads: tripsTrailheads.trailheads,
    trailheadsToggled: sidebar.trailheads,
    trips: tripsTrailheads.trips,
    selected: tripsTrailheads.selected,
    selector: tripsTrailheads.selector,
  };
};

export default connect(mapStateToProps, {
  enableDistanceReadout,
  disableDistanceReadout,
  selectTripTrailhead,
  deselectTripTrailhead,
  sidebarOpen,
})(LeafletMap);



// WEBPACK FOOTER //
// ./map/containers/LeafletMapConnected.js